module.exports = __webpack_public_path__ + "static/media/silver_badge.1f4f3d80.png";